module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('app-header')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0275a5ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Layout.vue
// module id = 411
// module chunks = 0